import { defineMessages } from 'react-intl';

export const createStringFromTemplate = (
  template: string,
  variables: Record<string, string>,
): string =>
  template.replace(
    new RegExp('{([^{]+)}', 'g'),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (_, varKey) => variables[varKey] || '',
  );

export const formValidationMessages = defineMessages({
  required: {
    id: 'Forms.validation.required',
    defaultMessage: '{label} is required!',
  },
  pattern: {
    id: 'Forms.validation.pattern',
    defaultMessage: '{label} is not a valid {label}!',
  },
  whitespace: {
    id: 'Forms.validation.whitespace',
    defaultMessage: '{label} must not be empty',
  },
  requiredPermission: {
    id: 'Forms.validation.requiredPermission',
    defaultMessage: 'At least one permission',
  },
});
